import { MenuItem, Select, css, styled } from "@mui/material";

import ChevronIcon from "assets/icons/outlined/chevron-right.svg?react";

import colors from "theme/colors";

export const TableContainer = styled("div")`
	border: 1px solid ${colors.palette.colors.gray["200"]};
	border-radius: 8px;
	overflow: hidden;
	padding: 0;
	width: 100%;
	height: 100%;
	position: relative;

	& > div {
		::-webkit-scrollbar {
			display: none;
		}
	}

	table {
		width: 100%;

		thead {
			tr {
				th {
					background-color: ${colors.palette.colors.lightGray};

					&:not(:last-of-type) {
						border-right: 1px solid ${colors.palette.colors.gray["200"]};
					}
				}
			}
		}

		tbody {
			tr {
				&:first-of-type {
					td {
						border-top: 1px solid ${colors.palette.colors.gray["200"]};
					}
				}

				td {
					&.body-td {
						padding: 12px 16px;
					}

					border-bottom: 1px solid ${colors.palette.colors.gray["200"]};

					&:not(:last-of-type) {
						border-right: 1px solid ${colors.palette.colors.gray["200"]};
					}

					&:first-of-type {
						background-color: ${colors.palette.colors.lightGray};
					}

					.border {
						&_DEFAULT {
							background-color: transparent;
						}

						&_ERROR {
							background-color: ${colors.palette.colors.red["500"]};
						}

						&_WARNING {
							background-color: ${colors.palette.colors.orange["500"]};
						}

						&_SUCCESS {
							background-color: ${colors.palette.colors.green["500"]};
						}
					}
				}
			}
		}
	}
`;

const MuiOutlinedInputStyles = css`
	font-size: 1rem;
	line-height: 1.5rem;
	border-radius: 8px;
	background-color: ${colors.palette.colors.white};

	textarea,
	input {
		color: ${colors.palette.colors.lightBlack};

		&::placeholder {
			font-size: 1rem;
			line-height: 1.5rem;
			color: ${colors.palette.colors.hint};
			opacity: 1;
		}
	}

	fieldset {
		border: none;
	}

	&:hover fieldset {
		border: none;
	}
`;

export const UIKitDropdown = styled(Select)`
	.MuiSelect-select {
		padding: 12px 16px;
	}

	&.MuiOutlinedInput-root {
		${MuiOutlinedInputStyles}
	}

	.MuiSelect-select {
		display: flex;
		align-items: center;
	}
`;

export const StyledMenuItem = styled(MenuItem)`
	border-radius: 8px;

	padding: 10px 8px;

	&:hover {
		background-color: ${colors.palette.colors.gray["50"]};
	}
`;

export const StyledChevronIcon = styled(ChevronIcon)`
	top: calc(50% - 12px) !important;
	transform: rotate(90deg) !important;

	transition: transform 0.15s ease-in-out;

	&.MuiSelect-iconOpen {
		transform: rotate(-90deg) !important;
	}
`;
